import { render, staticRenderFns } from "./TooltipFabIconButton.vue?vue&type=template&id=403a24f9&"
import script from "./TooltipFabIconButton.vue?vue&type=script&lang=js&"
export * from "./TooltipFabIconButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports